import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import { FormControlLabel } from "material-ui/Form";
import Radio from "material-ui/Radio";
import { RadioGroup } from "material-ui/Radio";
import Checkbox from "material-ui/Checkbox";
import Switch from "material-ui/Switch";
import { FormGroup } from "material-ui/Form";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Grid from "material-ui/Grid";
import _ from 'lodash'

import dots_2_1 from "./../../static/img/dots/2-1.png";
import dots_2_2 from "./../../static/img/dots/2-2.png";
import dots_2_3 from "./../../static/img/dots/2-3.png";
import dots_2_4 from "./../../static/img/dots/2-4.png";

import dots_3_1 from "./../../static/img/dots/3-1.png";
import dots_3_2 from "./../../static/img/dots/3-2.png";
import dots_3_3 from "./../../static/img/dots/3-3.png";
import dots_3_4 from "./../../static/img/dots/3-4.png";
import dots_3_5 from "./../../static/img/dots/3-5.png";
import dots_3_6 from "./../../static/img/dots/3-6.png";
import dots_3_7 from "./../../static/img/dots/3-7.png";
import dots_3_8 from "./../../static/img/dots/3-8.png";

import dots_4_1 from "./../../static/img/dots/4-1.png";
import dots_4_2 from "./../../static/img/dots/4-2.png";
import dots_4_3 from "./../../static/img/dots/4-3.png";
import dots_4_4 from "./../../static/img/dots/4-4.png";
import dots_4_5 from "./../../static/img/dots/4-5.png";

import dots_5_1 from "./../../static/img/dots/5-1.png";
import dots_5_2 from "./../../static/img/dots/5-2.png";
import dots_5_3 from "./../../static/img/dots/5-3.png";
import dots_5_4 from "./../../static/img/dots/5-4.png";
import dots_5_5 from "./../../static/img/dots/5-5.png";
import dots_5_6 from "./../../static/img/dots/5-6.png";
import dots_5_7 from "./../../static/img/dots/5-7.png";
import dots_5_8 from "./../../static/img/dots/5-8.png";

import dots_6_1 from "./../../static/img/dots/6-1.png";
import dots_6_2 from "./../../static/img/dots/6-2.png";
import dots_6_3 from "./../../static/img/dots/6-3.png";
import dots_6_4 from "./../../static/img/dots/6-4.png";
import dots_6_5 from "./../../static/img/dots/6-5.png";
import dots_6_6 from "./../../static/img/dots/6-6.png";
import dots_6_7 from "./../../static/img/dots/6-7.png";
import dots_6_8 from "./../../static/img/dots/6-8.png";

import dots_7_1 from "./../../static/img/dots/7-1.png";
import dots_7_2 from "./../../static/img/dots/7-2.png";
import dots_7_3 from "./../../static/img/dots/7-3.png";
import dots_7_4 from "./../../static/img/dots/7-4.png";
import dots_7_5 from "./../../static/img/dots/7-5.png";
import dots_7_6 from "./../../static/img/dots/7-6.png";
import dots_7_7 from "./../../static/img/dots/7-7.png";
import dots_7_8 from "./../../static/img/dots/7-8.png";

import dots_8_1 from "./../../static/img/dots/8-1.png";
import dots_8_2 from "./../../static/img/dots/8-2.png";
import dots_8_3 from "./../../static/img/dots/8-3.png";
import dots_8_4 from "./../../static/img/dots/8-4.png";
import dots_8_5 from "./../../static/img/dots/8-5.png";
import dots_8_6 from "./../../static/img/dots/8-6.png";
import dots_8_7 from "./../../static/img/dots/8-7.png";

import dots_9_1 from "./../../static/img/dots/9-1.png";
import dots_9_2 from "./../../static/img/dots/9-2.png";
import dots_9_3 from "./../../static/img/dots/9-3.png";
import dots_9_4 from "./../../static/img/dots/9-4.png";
import dots_9_5 from "./../../static/img/dots/9-5.png";
import dots_9_6 from "./../../static/img/dots/9-6.png";
import dots_9_7 from "./../../static/img/dots/9-7.png";

const formMatrix = {
    '2': [
        [['1'], ['2']],
        [['2'], ['1']],
        [['1'], ['1']],
        [['1', '2']]
    ],
    '3': [
        [['1'], ['1', '2']],
        [['2'], ['1', '2']],
        [['1'], ['2'], ['3']],
        [['3'], ['2'], ['1']],
        [['2'], ['1', '3']],
        [['1'], ['2'], ['1']],
        [['1'], ['1'], ['1']],
        [['1', '2', '3']]
    ],
    '4': [
        [['1', '2'], ['1', '2']],
        [['1', '2', '3', '4']],
        [['1'], ['1'], ['1', '2']],
        [['3'], ['1', '2', '3']],
        [['2', '4'], ['1', '3']]
    ],
    '5': [
        [['1', '3'], ['2'], ['1', '3']],
        [['1', '2'], ['3'], ['1', '2']],
        [['2', '3'], ['1', '2', '3']],
        [['1', '2', '3'], ['2', '3']],
        [['1', '3'], ['1', '2', '3']],
        [['1', '2', '3', '4', '5']],
        [['2', '4'], ['1', '3', '5']],
        [['1', '3', '5'], ['2', '4']]
    ],
    '6': [
        [['1', '3'], ['2', '4'], ['1', '3']],
        [['2', '4'], ['1', '3'], ['2', '4']],
        [['1', '2', '4'], ['1', '2', '4']],
        [['1', '3', '4'], ['1', '3', '4']],
        [['1', '2', '3'], ['1', '2', '3']],
        [['1', '2'], ['1', '2'], ['1', '2']],
        [['1', '3'], ['1', '2', '3', '4']],
        [['2', '5'], ['1', '3', '4', '6']]
    ],
    '7': [
        [['4', '5'], ['1', '2', '3', '4', '5']],
        [['1', '2', '3', '4', '5'], ['4', '5']],
        [['1', '3', '4'], ['1', '2', '3', '4']],
        [['1', '2', '4'], ['1', '2', '3', '4']],
        [['1', '3', '4'], ['2'], ['1', '3', '4']],
        [['1', '2', '4'], ['3'], ['1', '2', '4']],
        [['1', '2', '3'], ['4'], ['1', '2', '3']],
        [['2', '3', '4'], ['1'], ['2', '3', '4']]
    ],
    '8': [
        [['1', '2'], ['1', '2', '3'], ['1', '2', '3']],
        [['2', '3'], ['1', '2', '3'], ['1', '2', '3']],
        [['1', '2', '3', '4'], ['1', '2', '3', '4']],
        [['1', '2', '3'], ['1', '2', '3', '4', '5']],
        [['1', '2', '3', '4', '5'], ['1', '2', '3']],
        [['1', '2', '3', '5'], ['1', '2', '3', '5']],
        [['1', '3', '4', '5'], ['1', '3', '4', '5']]
    ],
    '9': [
        [['1', '2', '3'], ['1', '2', '3'], ['1', '2', '3']],
        [['1', '2', '3', '4'], ['1', '2', '3', '4', '5']],
        [['1', '2', '3', '4', '5'], ['2', '3', '4', '5']],
        [['1', '2', '3', '4', '5'], ['1', '2', '3', '4']],
        [['2', '3', '4', '5'], ['1', '2', '3', '4', '5']],
        [['1', '2', '3', '4'], ['5'], ['1', '2', '3', '4']],
        [['2', '3', '4', '5'], ['1'], ['2', '3', '4', '5']]
    ]
}

const styles = {
    closeIcon: {
        position: "absolute",
        top: "10px",
        right: "10px",
        color: "#a9a9a9",
        cursor: "pointer"
    },
    dotsDialog: {
        justifyContent: 'flex-start',
        padding: '20px'
    },
    group: {
        flexDirection: 'row'
    },
    img: {
        height: '100px',
        width: 'auto'
    }
};

class DotsLayoutDialog extends Component {
    classes = this.props.classes;
    state = {
        matrixSettings: {}
    }
    componentWillReceiveProps(props) {
        if (props.matrix) {
            let matrixSettings = this.state.matrixSettings
            Object.keys(props.matrix).forEach(key => {
                if(formMatrix[key] instanceof Array){
                    formMatrix[key].map((value1, index)=> {
                        props.matrix[key].forEach(value2 => {
                            if(_.isEqual(value1, value2)){
                                matrixSettings[key + '_' + index] = true
                            }
                        })
                    })
                }
                
            })
            this.setState({ matrixSettings })
        }
    }

    handleChange = (name, event) => {
        let matrixSettings = this.state.matrixSettings
        matrixSettings[name] = event.target.checked
        this.setState({ matrixSettings })
    }
    handleCloseModal = () => {
        let matrix = this.buildMatrix(this.state.matrixSettings)
        this.props.onChange(matrix)
        this.props.onClose()
    }
    buildMatrix = (matrixSettings) => {
        let matrix = {}
        Object.keys(matrixSettings).forEach((key) => {
            let value = matrixSettings[key]
            if (value === true) {
                let keys = key.split('_')
                if (keys.length === 2) {
                    if(!matrix[keys[0]]){
                        matrix[keys[0]] = []
                    }
                    matrix[keys[0]].push(formMatrix[keys[0]][keys[1]])
                }
            }
        })
        return matrix
    }
    render() {
        let open = this.props.open || false
        let matrixSettings = this.state.matrixSettings
        return (
            <Dialog
                maxWidth='md'
                open={open}
                onClose={this.handleCloseModal}
            >
                <DialogTitle>
                    <Icon
                        className={this.classes.closeIcon}
                        onClick={this.handleCloseModal}
                    >
                        close
                        </Icon>
                    <br />
                    Choose Dots Layout
                        </DialogTitle>
                <DialogActions className={this.classes.dotsDialog}>
                    <Grid>
                        <Grid>
                            <h3>2 dots</h3>
                            <FormGroup
                                aria-label="dots"
                                name="dots_2"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('2_0', event) }} checked={matrixSettings['2_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_2_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('2_1', event) }} checked={matrixSettings['2_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_2_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('2_2', event) }} checked={matrixSettings['2_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_2_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('2_3', event) }} checked={matrixSettings['2_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_2_4} />} />

                            </FormGroup>
                        </Grid>

                        <Grid>
                            <h3>3 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_3"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_0', event) }} checked={matrixSettings['3_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_1', event) }} checked={matrixSettings['3_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_2', event) }} checked={matrixSettings['3_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_3', event) }} checked={matrixSettings['3_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_4', event) }} checked={matrixSettings['3_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_5', event) }} checked={matrixSettings['3_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_6', event) }} checked={matrixSettings['3_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_7} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('3_7', event) }} checked={matrixSettings['3_7'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_3_8} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>4 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_4"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('4_0', event) }} checked={matrixSettings['4_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_4_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('4_1', event) }} checked={matrixSettings['4_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_4_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('4_2', event) }} checked={matrixSettings['4_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_4_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('4_3', event) }} checked={matrixSettings['4_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_4_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('4_4', event) }} checked={matrixSettings['4_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_4_5} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>5 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_5"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_0', event) }} checked={matrixSettings['5_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_1', event) }} checked={matrixSettings['5_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_2', event) }} checked={matrixSettings['5_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_3', event) }} checked={matrixSettings['5_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_4', event) }} checked={matrixSettings['5_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_5', event) }} checked={matrixSettings['5_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_6', event) }} checked={matrixSettings['5_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_7} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('5_7', event) }} checked={matrixSettings['5_7'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_5_8} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>6 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_6"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_0', event) }} checked={matrixSettings['6_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_1', event) }} checked={matrixSettings['6_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_2', event) }} checked={matrixSettings['6_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_3', event) }} checked={matrixSettings['6_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_4', event) }} checked={matrixSettings['6_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_5', event) }} checked={matrixSettings['6_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_6', event) }} checked={matrixSettings['6_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_7} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('6_7', event) }} checked={matrixSettings['6_7'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_6_8} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>7 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_7"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_0', event) }} checked={matrixSettings['7_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_1', event) }} checked={matrixSettings['7_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_2', event) }} checked={matrixSettings['7_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_3', event) }} checked={matrixSettings['7_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_4', event) }} checked={matrixSettings['7_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_5', event) }} checked={matrixSettings['7_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_6', event) }} checked={matrixSettings['7_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_7} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('7_7', event) }} checked={matrixSettings['7_7'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_7_8} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>8 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_8"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_0', event) }} checked={matrixSettings['8_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_1', event) }} checked={matrixSettings['8_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_2', event) }} checked={matrixSettings['8_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_3', event) }} checked={matrixSettings['8_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_4', event) }} checked={matrixSettings['8_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_5', event) }} checked={matrixSettings['8_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('8_6', event) }} checked={matrixSettings['8_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_8_7} />} />

                            </RadioGroup>
                        </Grid>

                        <Grid>
                            <h3>9 dots</h3>
                            <RadioGroup
                                aria-label="dots"
                                name="dots_9"
                                className={this.classes.group}
                            >
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_0', event) }} checked={matrixSettings['9_0'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_1} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_1', event) }} checked={matrixSettings['9_1'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_2} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_2', event) }} checked={matrixSettings['9_2'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_3} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_3', event) }} checked={matrixSettings['9_3'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_4} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_4', event) }} checked={matrixSettings['9_4'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_5} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_5', event) }} checked={matrixSettings['9_5'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_6} />} />
                                <FormControlLabel control={<Switch onChange={(event) => { this.handleChange('9_6', event) }} checked={matrixSettings['9_6'] === true ? true : false} />} label={<img className={this.classes.img} src={dots_9_7} />} />

                            </RadioGroup>
                        </Grid>

                    </Grid>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(DotsLayoutDialog);



// WEBPACK FOOTER //
// ./src/components/content/DotsLayoutDialog.js